/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IpsIcon extends BaseIcon {
  getChildren = () => [
    <title>iam protection</title>,
    <path
      fill="#aab4c4"
      d="
        M19.77,19.47l-7.93,4.68L3.72,19.47.58,3.62,11.84.15l11,
        3.47Zm-3.49-8.86a6.47,6.47,0,0,0-1.34,1.18l.9-2a4.06,4.06,
        0,0,0-4-2.82,3.93,3.93,0,0,0-4.13,3.67,3.1,3.1,0,0,0,.09.69A2.63,
        2.63,0,0,0,5.39,14a2.5,2.5,0,0,0,.23,1h12a2.76,2.76,0,0,0,.58-1.65A3.21,3.21,0,0,0,16.28,10.61Z
      "
    />
  ]
  getViewBox = () => '0 0 24 24'
}
